import React from 'react';
import CaseStudyLayout from '../../../components/caseStudy/index';
import { Intern } from '../image_index';
import { sections } from './config';

const CiscoIntern = () => {
    return (
        <CaseStudyLayout
            title='Cisco AppDynamics Internship'
            subtitle='Cross-Functional Product Design & Frontend Development'
            heroImage={[Intern]}
            duration='June 2022 - March 2023'
            tools='Figma, React, HTML, CSS, SCSS, Javascript'
            role='UX Prototype Designer Intern'
            summary={(
                <p>
                    An overview of my contributions across key product design and frontend initiatives. While specific client deliverables remain confidential, this case study highlights my end-to-end design process, component systems work, and collaborative workflows bridging UI/UX and engineering.
                </p>
            )}
            sections={sections}
        />
    );
}

export default CiscoIntern;